import React, { useState } from "react";
import DeviceStore from "../../../store/DeviceStore";
import { observer } from "mobx-react";
import { ListBox } from "primereact/listbox";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import AddDeviceModal from "./addDeviceModal/AddDeviceModal";
import { classNames } from "primereact";
import {
  DeviceType,
  DesktopClient,
} from "../../../api/firebase/types/device.types";
import { screenSize, useMediaQuery } from "../../../hooks/responsiveLayout";
import { FormControlProps } from "../../../components/validation/FormControlled";
import DeviceListTemplate from "./DeviceListTemplate";

export type DeviceListCardProps = {
  devices: (DeviceType | DesktopClient)[];
  className?: string;
  useFormMethods: FormControlProps;
};

const DeviceListCard: React.FC<DeviceListCardProps> = ({
  devices,
  className,
  useFormMethods,
}) => {
  const [isAddDialogVisible, setIsAddDialogVisible] = useState(false);

  const [width] = useMediaQuery();

  const addDeviceButton = (
    <Button
      key="add-button"
      icon="pi pi-plus"
      className="p-button-text"
      style={{ height: 40 }}
      label="Neue Meldeinstanz"
      onClick={() => setIsAddDialogVisible(true)}
    />
  );

  const handleDeviceChange = (deviceDocId: string) => {
    useFormMethods.reset();
    DeviceStore.setCurrentDevice(deviceDocId);
  };
  return (
    <Card
      className={classNames("devicelist p-col", {
        "p-mr-2": width >= screenSize.tablet,
      })}
    >
      <Toolbar
        left={() => <h2>Meldeinstanzen</h2>}
        right={() => addDeviceButton}
      />
      <p className="p-mt-0">
        <i>Hier können Sie Meldeinstanzen verwalten.</i>
      </p>
      {devices.length > 0 ? (
        <ListBox
          className={className}
          value={DeviceStore.currentDevice?.id}
          options={devices}
          optionValue="id"
          optionLabel="name"
          onChange={(e) => handleDeviceChange(e.value)}
          itemTemplate={DeviceListTemplate}
          placeholder="Keine registrierten Meldeinstanzen"
        />
      ) : (
        <p>
          <i>Keine registrierten Meldeinstanzen</i>
        </p>
      )}
      <AddDeviceModal
        isVisible={isAddDialogVisible}
        closeModal={() => setIsAddDialogVisible(false)}
      />
    </Card>
  );
};

export default observer(DeviceListCard);
